export const mediaLightLogo = 'https://wsr.nhle.com/images/media-logo.svg';
export const mediaDarkLogo = 'https://wsr.nhle.com/images/media-logo-on-dark.svg';
export const mediaFadedLogo = 'https://wsr.nhle.com/images/media-faded-logo.svg';
export const mediaEmailHeader = 'https://wsr.nhle.com/images/media-email-header.png';
export const mediaScreenerEmailHeader = 'https://wsr.nhle.com/images/media-screener-email-header.png';
